import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
export interface TabListItem {
  label: string;
  value: string;
}
export interface TabListProps {
  activeValue: string;
  tabList: TabListItem[];
  onTabClick: (value: string) => void;
}
const TabList = (props: TabListProps) => {
  const [activeValue, setActiveValue] = useState<string>(props.activeValue);
  useEffect(() => {
    setActiveValue(props.activeValue);
  }, [props.activeValue]);

  return (
    <ul className="tablist-content">
      {props.tabList?.map((item: TabListItem, index: number) => {
        return (
          <li
            key={item.value}
            onClick={() => {
              setActiveValue(item.value);
              props.onTabClick(item.value);
            }}
            className={classNames('tab-item', {
              'tab-item-active': item.value === activeValue,
            })}
          >
            <i className="vehicle-icon"></i>
            <i>{item.label}</i>
          </li>
        );
      })}
    </ul>
  );
};
export default TabList;
